var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIstio = function SvgIstio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "istio_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 160 240"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".istio_svg__st0{fill:#466bb0}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "istio_svg__logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "istio_svg__hull",
    d: "M0 210h160L60 240z",
    className: "istio_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "istio_svg__mainsail",
    d: "m0 200 60-10V80z",
    className: "istio_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "istio_svg__headsail",
    d: "m70 190 90 10L70 0z",
    className: "istio_svg__st0"
  }))));
};
export { SvgIstio as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0iTGF5ZXJfMSIgeD0iMCIgeT0iMCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMTYwIDI0MCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYwIDI0MCI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzQ2NmJiMH08L3N0eWxlPjxnIGlkPSJsb2dvIj48cG9seWdvbiBpZD0iaHVsbCIgcG9pbnRzPSIwIDIxMCAxNjAgMjEwIDYwIDI0MCIgY2xhc3M9InN0MCIvPjxwb2x5Z29uIGlkPSJtYWluc2FpbCIgcG9pbnRzPSIwIDIwMCA2MCAxOTAgNjAgODAiIGNsYXNzPSJzdDAiLz48cG9seWdvbiBpZD0iaGVhZHNhaWwiIHBvaW50cz0iNzAgMTkwIDE2MCAyMDAgNzAgMCIgY2xhc3M9InN0MCIvPjwvZz48L3N2Zz4=";